import { Action } from '@ngrx/store';

// Interfaces
import * as interfaces from '../interfaces';

// Constants - General
export const RESET_PROJECT = '[Project] Reset Project';
export const GET_PROJECT_BY_ID = '[Project] Get Project by ID';
export const GET_PROJECT_BY_ID_SUCCESS = '[Project] Get Project by ID Success';
export const GET_CURRENT_USER_ROLES_AND_PERMISSIONS = '[Project] Get Current User Roles and Permission';
export const GET_CURRENT_USER_ROLES_AND_PERMISSIONS_SUCCESS = '[Project] Get Current User Roles and Permission Success';
export const CHANGE_PROJECT_LANGUAGE_SELECTED = '[Project] Change Project Language Selected';
export const GET_WIZARD_DATA = '[Project] Get Wizard Data';
export const GET_WIZARD_DATA_SUCCESS = '[Project] Get Wizard Data Success';
export const GET_PROJECT_SETTINGS = '[Project - Settings] Get Project Settings';
export const GET_PROJECT_SETTINGS_SUCCESS = '[Project - Settings] Get Project Settings Success';
export const EXPORT_PROJECT = '[Project - Settings] Export the Entire Project';
export const REQUEST_SEND = '[Project - Settings] Request send by email the Entire Project';
export const EXPORT_PROJECT_SUCCESS = '[Project - Settings] Export the Entire Project Success';
export const EXPORT_PROJECT_ERROR = '[Project - Settings] Export the Entire Project Error';
// Constants - Project Content - Focus Prompt
export const GET_FOCUS_PROMPT = '[Project - Settings] Get Focus Prompt';
export const SAVE_FOCUS_PROMPT = '[Project - Settings] Save Focus Prompt';
export const GET_FOCUS_PROMPT_SUCCESS = '[Project - Settings] Get Focus Prompt Success';
export const SAVE_FOCUS_PROMPT_WARNING = '[Project - Settings] Save Focus Prompt Warning';
// Constants - Project Content - Informed Consent
export const GET_INFORMED_CONSENT = '[Project - Settings] Get Informed Consent';
export const SAVE_INFORMED_CONSENT = '[Project - Settings] Save Informed Consent';
export const SAVE_INFORMED_CONSENT_FAIL = '[Project - Settings] Save Informed Consent Fail';
export const GET_INFORMED_CONSENT_SUCCESS = '[Project - Settings] Get Informed Consent Success';
export const SET_DEFAULT_INFORMED_CONSENT = '[Project - Settings] Set Default Informed Consent Success';
export const REMOVE_INFORMED_CONSENT_FILE = '[Project - Settings] Remove Informed Consent File';
export const SAVE_INFORMED_CONSENT_SUCCESS = '[Project - Settings] Save Informed Consent Success';
export const REMOVE_INFORMED_CONSENT_FILE_SUCCESS = '[Project - Settings] Remove Informed Consent File Success';
export const REMOVE_INFORMED_CONSENT_FILE_WARNING = '[Project - Settings] Remove Informed Consent File Warning';
export const TOGGLE_INFORMED_CONSENT_UPLOAD_MODAL = '[Project - Settings] Toggle Informed Consent Upload Modal';
// Constants - Project Content - Welcome Message
export const GET_PROJECT_WELCOME_MESSAGE = '[Project - Settings] Get Project Welcome Message';
export const SAVE_PROJECT_WELCOME_MESSAGE = '[Project - Settings] Save Project Welcome Message';
export const SET_PROJECT_DEFAULT_WELCOME_TEXT = '[Project - Settings] set Project Default Welcome Text';
export const SET_PROJECT_DEFAULT_WELCOME_TITLE = '[Project - Settings] set Project Default Welcome Title';
export const GET_PROJECT_WELCOME_MESSAGE_SUCCESS = '[Project - Settings] Get Project Welcome Message Success';
// Constants - Project Content - Thank You Message
export const GET_PROJECT_THANK_YOU_MESSAGE = '[Project - Settings] Get Project Thank You Message';
export const SAVE_PROJECT_THANK_YOU_MESSAGE = '[Project - Settings] Save Project Thank You Message';
export const SET_PROJECT_DEFAULT_THANK_YOU_TEXT = '[Project - Settings] set Project Default Thank You Text';
export const SET_PROJECT_DEFAULT_THANK_YOU_TITLE = '[Project - Settings] set Project Default Thank You Title';
export const GET_PROJECT_THANK_YOU_MESSAGE_SUCCESS = '[Project - Settings] Get Project Thank You Message Success';
// Constants - Admin Management
export const GET_USER_LIST_PROJECT = '[Project - Settings] Get The User List Of Project';
export const INVITE_USER_TO_PROJECT = '[Project - Settings] Invite user to project with role';
export const ASSIGN_USER_PERMISSIONS = '[Project - Settings] Assing User Permissions';
export const DELETE_USER_PROJECT = '[Project - Settings] Delete User from Project';
export const DELETE_USER_PROJECT_FAIL = '[Project - Settings] Delete user from project fail';
export const DEACTIVATE_USER_PROJECT = '[Project - Settings] Deactivate User from Project';
export const TOGGLE_SELECT_ROLE_MODAL = '[Project - Settings] Toggle Select Role Modal';
export const TOGGLE_INVITE_USER_MODAL = '[Project - Settings] Toggle Invite User Modal';
export const DELETING_USER_WARNING = '[Project - Settings] Deleting User Warning';
export const DEACTIVATING_USER_WARNING = '[Project - Settings] Deactivating User Warning';
export const GET_ROLES_AND_PERMISSIONS = '[Project - Settings] Get Roles and Permissions';
export const INVITE_USER_TO_PROJECT_FAIL = '[Project - Settings] Invite user to project with role fail';
export const TOGGLE_EDIT_USER_PERMISSIONS = '[Project - Settings] Toggle Edit User Permissions Component';
export const GET_USER_LIST_PROJECT_SUCCESS = '[Project - Settings] Get User List Of Project Success';
export const GET_USER_ROLES_AND_PERMISSIONS = '[Project - Settings] Get the User Roles and Permissions';
export const GET_ROLES_AND_PERMISSIONS_SUCCESS = '[Project - Settings] Get Roles and Permissions Success';
export const TOGGLE_REMOVING_PERMISSIONS_WARNING = '[Project - Settings] Toggle Removing Permissions Warning Modal';
export const GET_USER_ROLES_AND_PERMISSIONS_SUCCESS = '[Project - Settings] Get the User Roles and Permissions Success';
// Constants - Project Settings - Project Settings
export const UPDATE_PROJECT_LOGO = '[Project - Settings] Update Project Logo';
export const PARTICIPANT_PREVIEW = '[Project - Settings] Participant Preview';
export const EDIT_PROJECT_CONTACT = '[Project - Settings] Change Project Contact Data';
export const CHANGE_PROJECT_STATUS = '[Project - Settings] Change Project Status';
export const EDIT_PROJECT_INFORMATION = '[Project - Settings] Edit Project Information';
export const RESET_LOGO_ERROR_MESSAGE = '[Project - Settings] Reset Logo Error Message';
export const RESET_PROJECT_LOGO_ERROR = '[Project - Settings] Reset Project Logo Fail Error Message';
export const UPDATE_PROJECT_LOGO_FAIL = '[Project - Settings] Update Project Logo Fail';
export const UPDATE_PROJECT_LOGO_FAIL_ERROR = '[Project - Settings] Update Project Logo Fail Error Message';
export const TOGGLE_CHANGE_PROJECT_STATUS_WARNING_MODAL = '[Project - Settings] Toggle Change Project Status Warning Modal';
export const SET_SETTING_TAB = '[Project - Settings] Set Project Setting Tab';
export const GET_SETTING_MENU = '[Project] Get Project Setting Menu';
export const GET_SETTING_MENU_SUCCESS = '[Project] Get Project Setting Menu Success';
// Constants - Project common catalogue
export const GET_RANDOMIZE_TYPE = '[Project - Settings] - Get Randomize Type';
export const GET_RANDOMIZE_TYPE_SUCCESS = '[Project - Settings] - Get Randomize Type Success';
export const GET_REGISTRATION_TYPE = '[Project - Settings] - Get Registration Type';
export const GET_REGISTRATION_TYPE_SUCCESS = '[Project - Settings] - Get Registration Type Success';
export const GET_OPEN_CLOSE_TYPE = '[Project - Settings] Get Open Close Type';
export const GET_OPEN_CLOSE_TYPE_SUCCESS = '[Project - Settings] Get Open Close Type Success';
export const GET_LAYOUT_TYPE = '[Project - Settings] Get Layout Type';
export const GET_LAYOUT_TYPE_SUCCESS = '[Project - Settings] Get Layout Type Success';

export const GET_ACTIVITY_STATUS = '[Project - Settings] Get Activity Status';
export const GET_ACTIVITY_STATUS_SUCCESS = '[Project - Settings] Get Activity Status Success';
export const CHANGE_ACTIVITY_STATUS = '[Project - Landing] - Change Activity Status';

export const UPDATE_RATING_QUESTION = '[Project] - Change Activity Status';
export const GET_USER_PROJECT_PERMISSIONS = '[Project - User] Get User Project Permissions';
export const GET_USER_PROJECT_PERMISSIONS_SUCCESS = '[Project - User] Get User Project Permissions Success';

// Actions - General
export class ResetProject implements Action {
  readonly type = RESET_PROJECT;
}
export class GetProjectByID implements Action {
  readonly type = GET_PROJECT_BY_ID;
  constructor(public payload: number) {}
}
export class GetProjectByIDSuccess implements Action {
  readonly type = GET_PROJECT_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class GetCurrentUserRolesAndPermissions implements Action {
  readonly type = GET_CURRENT_USER_ROLES_AND_PERMISSIONS;
  constructor(public payload: { project_id: number, getProject: boolean }) {}
}
export class GetCurrentUserRolesAndPermissionsSuccess implements Action {
  readonly type = GET_CURRENT_USER_ROLES_AND_PERMISSIONS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetProjectSettings implements Action {
  readonly type = GET_PROJECT_SETTINGS;
  constructor(public payload: { project_id: number }) {}
}
export class GetProjectSettingsSuccess implements Action {
  readonly type = GET_PROJECT_SETTINGS_SUCCESS;
  constructor(public payload: any) {}
}
export class ExportProject implements Action {
  readonly type = EXPORT_PROJECT;
  constructor(public payload: { project_id: number }) {}
}
export class RequestSend implements Action {
  readonly type = REQUEST_SEND;
  constructor(public payload: { project_id: number }) {}
}
export class ExportProjectSuccess implements Action {
  readonly type = EXPORT_PROJECT_SUCCESS;
  constructor(public payload: any) {}
}
export class ExportProjectError implements Action {
  readonly type = EXPORT_PROJECT_ERROR;
  constructor(public payload: any) {}
}
export class GetUserProjectPermissions implements Action {
  readonly type = GET_USER_PROJECT_PERMISSIONS;
  constructor(public payload: { project_id: number }) {}
}
export class GetUserProjectPermissionsSuccess implements Action {
  readonly type = GET_USER_PROJECT_PERMISSIONS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetWizardData implements Action {
  readonly type = GET_WIZARD_DATA;
  constructor(public payload: { project_id: number }){}
}
export class GetWizardDataSuccess implements Action {
  readonly type = GET_WIZARD_DATA_SUCCESS;
  constructor(public payload: any){}
}
// Actions - Project Content - Focus Prompt
export class GetFocusPrompt implements Action {
  readonly type = GET_FOCUS_PROMPT;
  constructor(public payload: { lan_code: string, project_id: number }) {}
}
export class SaveFocusPrompt implements Action {
  readonly type = SAVE_FOCUS_PROMPT;
  constructor(public payload: { project_id: number, project_prompt: string, font: number, project_lan: string }) {}
}
export class GetFocusPromptSuccess implements Action {
  readonly type = GET_FOCUS_PROMPT_SUCCESS;
  constructor(public payload: string) {}
}
export class SaveFocusPromptWarning implements Action {
  readonly type = SAVE_FOCUS_PROMPT_WARNING;
}
// Actions - Project Content - Informed Consent
export class GetInformedConsent implements Action {
  readonly type = GET_INFORMED_CONSENT;
  constructor(public payload: { lan_code: string, project_id: number }) {}
}
export class SaveInformedConsent implements Action {
  readonly type = SAVE_INFORMED_CONSENT;
  constructor(public payload: any, public closeModal?: boolean) {}
}
export class SaveInformedConsentFail implements Action {
  readonly type = SAVE_INFORMED_CONSENT_FAIL;
  constructor(public payload: string) {}
}
export class GetInformedConsentSuccess implements Action {
  readonly type = GET_INFORMED_CONSENT_SUCCESS;
  constructor(public payload: any) {}
}
export class SetDefaultInformedConsent implements Action {
  readonly type = SET_DEFAULT_INFORMED_CONSENT;
  constructor(public payload: { lan_code: string, project_id: number }) {}
}
export class RemoveInformedConsentFile implements Action {
  readonly type = REMOVE_INFORMED_CONSENT_FILE;
  constructor(public payload: number) {}
}
export class SaveInformedConsentSuccess implements Action {
  readonly type = SAVE_INFORMED_CONSENT_SUCCESS;
  constructor(public payload: { lan_code: string, project_id: number }) {}
}
export class RemoveInformedConsentFileSuccess implements Action {
  readonly type = REMOVE_INFORMED_CONSENT_FILE_SUCCESS;
}
export class RemoveInformedConsentFileWarning implements Action {
  readonly type = REMOVE_INFORMED_CONSENT_FILE_WARNING;
}
export class ToggleInformedConsentUploadModal implements Action {
  readonly type = TOGGLE_INFORMED_CONSENT_UPLOAD_MODAL;
}
// Actions - Project Content - Welcome Message
export class GetProjectWelcomeMessage implements Action {
  readonly type = GET_PROJECT_WELCOME_MESSAGE;
  constructor(public payload: { lan_code: string, project_id: number }) {}
}
export class SaveProjectWelcomeMessage implements Action {
  readonly type = SAVE_PROJECT_WELCOME_MESSAGE;
  constructor(public payload: { project_id: number, welcome_title: string, welcome_message: string, welcome_lan: string }) {}
}
export class GetProjectWelcomeMessageSuccess implements Action {
  readonly type = GET_PROJECT_WELCOME_MESSAGE_SUCCESS;
  constructor(public payload: { title: string, titleDefault: boolean, message: string, messageDefault: boolean }) {}
}
export class SetProjectDefaultWelcomeTitle implements Action {
  readonly type = SET_PROJECT_DEFAULT_WELCOME_TITLE;
  constructor(public payload: { lan_code: string, project_id: number }) {}
}
export class SetProjectDefaultWelcomeText implements Action {
  readonly type = SET_PROJECT_DEFAULT_WELCOME_TEXT;
  constructor(public payload: { lan_code: string, project_id: number }) {}
}

// Actions - Project Content - Thank You Message
export class GetProjectThankYouMessage implements Action {
  readonly type = GET_PROJECT_THANK_YOU_MESSAGE;
  constructor(public payload: { lan_code: string, project_id: number }) {}
}
export class SaveProjectThankYouMessage implements Action {
  readonly type = SAVE_PROJECT_THANK_YOU_MESSAGE;
  constructor(public payload: {
    project_id: number,
    project_title: string,
    project_message: string,
    project_lan: string,
    project_status: boolean,
    project_url: string
  }, public refresh: boolean = false) {}
}
export class GetProjectThankYouMessageSuccess implements Action {
  readonly type = GET_PROJECT_THANK_YOU_MESSAGE_SUCCESS;
  constructor(public payload: { title: string, titleDefault: boolean, message: string, messageDefault: boolean, status: number, pcmt_url: string }) {}
}
export class SetProjectDefaultThankYouTitle implements Action {
  readonly type = SET_PROJECT_DEFAULT_THANK_YOU_TITLE;
  constructor(public payload: { lan_code: string, project_id: number }) {}
}
export class SetProjectDefaultThankYouText implements Action {
  readonly type = SET_PROJECT_DEFAULT_THANK_YOU_TEXT;
  constructor(public payload: { lan_code: string, project_id: number }) {}
}
export class ToggleSelectRoleModal implements Action {
  readonly type = TOGGLE_SELECT_ROLE_MODAL;
}
export class ToggleInviteUserModal implements Action {
  readonly type = TOGGLE_INVITE_USER_MODAL;
}
export class InviteUserToProject implements Action {
  readonly type = INVITE_USER_TO_PROJECT;
  constructor(public payload: { email: string, project_id: string, role: string }) {}
}
export class GetUserListProject implements Action {
  readonly type = GET_USER_LIST_PROJECT;
  constructor(public payload: { project_id: string }) {}
}
export class GetUserListProjectSuccess implements Action {
  readonly type = GET_USER_LIST_PROJECT_SUCCESS;
  constructor(public payload: any) {}
}
export class GetRolesAndPermissions implements Action {
  readonly type = GET_ROLES_AND_PERMISSIONS;
  constructor(public payload: { ownerIncluded: boolean, deep: boolean }) {}
}
export class GetRolesAndPermissionsSuccess implements Action {
  readonly type = GET_ROLES_AND_PERMISSIONS_SUCCESS;
  constructor(public payload: any) {}
}
export class ToggleEditUserPermissions implements Action {
  readonly type = TOGGLE_EDIT_USER_PERMISSIONS;
  constructor(public payload: any | null) {}
}
export class GetUserRolesAndPermissions implements Action {
  readonly type = GET_USER_ROLES_AND_PERMISSIONS;
  constructor(public payload: { userId: number, project_id: number }) {}
}
export class GetUserRolesAndPermissionsSuccess implements Action {
  readonly type = GET_USER_ROLES_AND_PERMISSIONS_SUCCESS;
  constructor(public payload: any) {}
}
export class AssignUserPermissions implements Action {
  readonly type = ASSIGN_USER_PERMISSIONS;
  constructor(public payload: { userId: number, project_id: number, role: string, permissions: Array<string>, closeModal?: boolean }) {}
}
export class DeleteUserFromProject implements Action {
  readonly type = DELETE_USER_PROJECT;
  constructor(public payload: { email: string, project_id: string }) {}
}
export class DeleteUserFromProjectFail implements Action {
  readonly type = DELETE_USER_PROJECT_FAIL;
  constructor(public payload: string) {}
}
export class DeactivateUserFromProject implements Action {
  readonly type = DEACTIVATE_USER_PROJECT;
  constructor(public payload: { email: string, project_id: string }) {}
}
export class InviteUserToProjectFail implements Action {
  readonly type = INVITE_USER_TO_PROJECT_FAIL;
  constructor(public payload: string) {}
}
export class ToggleRemovingPermissionsModal implements Action {
  readonly type = TOGGLE_REMOVING_PERMISSIONS_WARNING;
}
export class DeletingUserWarning implements Action {
  readonly type = DELETING_USER_WARNING;
}
export class DeactivatingUserWarning implements Action {
  readonly type = DEACTIVATING_USER_WARNING;
}

// Actions - General Settings - General Settings
export class UpdateProjectLogo implements Action {
  readonly type = UPDATE_PROJECT_LOGO;
  constructor(public payload: any) {}
}
export class ChangeProjectStatus implements Action {
  readonly type = CHANGE_PROJECT_STATUS;
  constructor(public payload: { project_id: number, status_id: number }) {}
}
export class ResetLogoErrorMessage implements Action {
  readonly type = RESET_LOGO_ERROR_MESSAGE;
}
export class ResetProjectLogoError implements Action {
  readonly type = RESET_PROJECT_LOGO_ERROR;
}
export class UpdateProjectLogoFail implements Action {
  readonly type = UPDATE_PROJECT_LOGO_FAIL;
  constructor(public payload: { code: number, error: any }) {}
}
export class EditProjectContactData implements Action {
  readonly type = EDIT_PROJECT_CONTACT;
  constructor(public payload: { project_id: number, contactEmail: string,
    countryCode: string, dialCode: string, phoneNumber: string}) {}
}
export class EditProjectInformation implements Action {
  readonly type = EDIT_PROJECT_INFORMATION;
  constructor(public payload: { project_id: number, name: string, abbreviation: string,
    color: string, logo: any, default_language: number, hide_english: number,
    notification_90: number, notification_95: number, notification_99: number}) {}
}
export class ToggleParticipantPreview implements Action {
  readonly type = PARTICIPANT_PREVIEW;
}
export class UpdateProjectLogoFailError implements Action {
  readonly type = UPDATE_PROJECT_LOGO_FAIL_ERROR;
  constructor(public payload: string) {}
}
export class ToggleChangeProjectStatusWarning implements Action {
  readonly type = TOGGLE_CHANGE_PROJECT_STATUS_WARNING_MODAL;
}
export class ChangeProjectLanguageSelected implements Action {
  readonly type = CHANGE_PROJECT_LANGUAGE_SELECTED;
  constructor(public payload: string) {}
}

export class GetRandomizeType implements Action {
  readonly type = GET_RANDOMIZE_TYPE;
}

export class GetRandomizeTypeSuccess implements Action {
  readonly type = GET_RANDOMIZE_TYPE_SUCCESS;
  constructor(public payload: any) {}
}

export class GetOpenCloseType implements Action {
  readonly type = GET_OPEN_CLOSE_TYPE;
}

export class GetOpenCloseTypeSuccess implements Action {
  readonly type = GET_OPEN_CLOSE_TYPE_SUCCESS;
  constructor(public payload: any) {}
}

export class GetLayoutType implements Action {
  readonly type = GET_LAYOUT_TYPE;
}

export class GetLayoutTypeSuccess implements Action {
  readonly type = GET_LAYOUT_TYPE_SUCCESS;
  constructor(public payload: any) {}
}

export class GetRegistrationType implements Action {
  readonly type = GET_REGISTRATION_TYPE;
}

export class GetRegistrationTypeSuccess implements Action {
  readonly type = GET_REGISTRATION_TYPE_SUCCESS;
  constructor(public payload: any) {}
}

export class GetActivityStatus implements Action {
  readonly type = GET_ACTIVITY_STATUS;
}

export class GetActivityStatusSuccess implements Action {
  readonly type = GET_ACTIVITY_STATUS_SUCCESS;
  constructor(public payload: any) {}
}
export class ChangeActivityStatus implements Action {
  readonly type = CHANGE_ACTIVITY_STATUS;
  constructor(public payload: { project_id: number, activity: any }) {}
}
export class SetProjectSettingTab implements Action {
  readonly type = SET_SETTING_TAB;
  constructor(public payload: number) {}
}

export class UpdateRatingQuestion implements Action {
  readonly type = UPDATE_RATING_QUESTION;
  constructor(public payload: any) {}
}

export class GetProjectSettingMenu implements Action {
  readonly type = GET_SETTING_MENU;
  constructor(public id: number) {}
}

export class GetProjectSettingMenuSuccess implements Action {
  readonly type = GET_SETTING_MENU_SUCCESS;
  constructor(public payload: any) {}
}

// Export Actions
export type Actions =
  | ResetProject
  | GetFocusPrompt
  | GetProjectByID
  | SaveFocusPrompt
  | GetInformedConsent
  | SaveInformedConsent
  | GetFocusPromptSuccess
  | GetProjectByIDSuccess
  | SaveFocusPromptWarning
  | SaveInformedConsentFail
  | GetInformedConsentSuccess
  | SetDefaultInformedConsent
  | RemoveInformedConsentFile
  | SaveInformedConsentSuccess
  | GetProjectWelcomeMessage
  | SaveProjectWelcomeMessage
  | GetProjectWelcomeMessageSuccess
  | SetProjectDefaultWelcomeTitle
  | SetProjectDefaultWelcomeText
  | RemoveInformedConsentFileSuccess
  | ToggleInformedConsentUploadModal
  | GetProjectThankYouMessage
  | SaveProjectThankYouMessage
  | GetProjectThankYouMessageSuccess
  | SetProjectDefaultThankYouTitle
  | SetProjectDefaultThankYouText
  | ToggleSelectRoleModal
  | ToggleInviteUserModal
  | InviteUserToProject
  | GetUserListProject
  | GetUserListProjectSuccess
  | GetRolesAndPermissions
  | GetRolesAndPermissionsSuccess
  | ToggleEditUserPermissions
  | GetUserRolesAndPermissions
  | GetUserRolesAndPermissionsSuccess
  | AssignUserPermissions
  | DeleteUserFromProject
  | DeactivateUserFromProject
  | InviteUserToProjectFail
  | DeleteUserFromProjectFail
  | EditProjectInformation
  | UpdateProjectLogo
  | UpdateProjectLogoFail
  | UpdateProjectLogoFailError
  | ResetProjectLogoError
  | ChangeProjectStatus
  | EditProjectContactData
  | ToggleRemovingPermissionsModal
  | GetCurrentUserRolesAndPermissionsSuccess
  | DeletingUserWarning
  | DeactivatingUserWarning
  | RemoveInformedConsentFileWarning
  | ToggleParticipantPreview
  | ToggleChangeProjectStatusWarning
  | ResetLogoErrorMessage
  | ChangeProjectLanguageSelected
  | GetRandomizeType
  | GetRandomizeTypeSuccess
  | GetOpenCloseType
  | GetOpenCloseTypeSuccess
  | GetLayoutType
  | GetLayoutTypeSuccess
  | GetRegistrationType
  | GetRegistrationTypeSuccess
  | GetWizardData
  | GetWizardDataSuccess
  | GetActivityStatus
  | GetActivityStatusSuccess
  | ChangeActivityStatus
  | SetProjectSettingTab
  | UpdateRatingQuestion
  | GetProjectSettings
  | GetProjectSettingsSuccess
  | ExportProject
  | ExportProjectSuccess
  | ExportProjectError
  | RequestSend
  | GetUserProjectPermissions
  | GetUserProjectPermissionsSuccess
  | GetProjectSettingMenu
  | GetProjectSettingMenuSuccess;



// WEBPACK FOOTER //
// ./src/app/project/actions/project.actions.ts